<template>
   <div id="app" >
    <keep-alive>
      <router-view v-if="!$route.meta.nokeep" />
    </keep-alive>
    <router-view v-if="$route.meta.nokeep" />
  </div>
</template>

<script>

import {getusersig} from '@/api/index.js'
import autofit from "autofit.js";
export default {
  name: "App",
  components: {

  },
  created() {
    // const devicePixelRatio = window.devicePixelRatio // 获取下载的缩放 125% -> 1.25    150% -> 1.5
    // if (devicePixelRatio >= 1.5) {
    //   // 老ie可以提示
    //   if (!! window.ActiveXObject || 'ActiveXObject' in window) {
    //     alert('balabala,去用chrome吧')
    //   } else {
    //     const c = document.querySelector('body')
    //     c.style.zoom = 1.25 / devicePixelRatio// 修改页面的缩放比例
    //   }
    // }    
  },
  mounted() {
    
    let addr = this.$store.state.point;
    if (!addr.latitude) {
      this.$store.dispatch("getArea");
    }

    autofit.init({
      designWidth: 1920,
      designHeight: window.innerHeight,
      el: "#app",
      resize: true
    });
    // this.$nextTick(() => {
    //   const $app = this.$refs.app;
    //   // 设置 屏幕 百分比 尺寸 适配
    //   const standardScale = "100%" / "100%";

    //   window.addEventListener(
    //     "resize",
    //     _.debounce(function () {
    //       const docHeight = document.body.clientHeight;
    //       const docWidth = document.body.clientWidth;
    //       console.log(docHeight,docWidth,66666)
    //       if (docWidth < 1680) {
    //         const currentScale = docHeight / docWidth;
    //         console.log(currentScale,standardScale,66666)
    //         let [scale, translate] = [0, 0];
    //         if (currentScale < standardScale) {
    //           console.log(6666666667)
    //           // 以高度计算
    //           scale = docHeight / 1080;
    //           const shouleWidth = 1920 * scale;
         
    //           const offsetWidth = docWidth - shouleWidth;
    //           translate =
    //             offsetWidth > 0 ? `translate(${offsetWidth / 2}px, 0)` : "";
    //         } else {
    //           // 以宽度计算
    //           scale = docWidth / 1920;
    //           const shouleHeight = 1080 * scale;
    //           const offsetHeight = docHeight - shouleHeight;
    //           translate =
    //             offsetHeight > 0 ? `translate(0, ${offsetHeight / 2}px)` : "";
    //         }
    //         console.log(translate);
    //         $app.style.cssText = `
    //         transform: scale(${scale}) ${translate};
    //         transform-origin: top left;
    //         min-width: 1920px;
    //         min-height: 1080px;
    //       `;
    //       } else {
    //         $app.style.cssText = "";
    //       }
    //     }),
    //     300
    //   );

    //   if (document.createEvent) {
    //     var event = document.createEvent("HTMLEvents");
    //     event.initEvent("resize", true, true);
    //     window.dispatchEvent(event);
    //   } else if (document.createEventObject) {
    //     window.fireEvent("onresize");
    //   }
    // });




    // try {
    //   let that = this
    //   this.isid()
    //   this.logins(JSON.parse(this.$store.state.userInfo).id.toString())
    //   let kk = localStorage.getItem('enterInfo')
    //   kk = JSON.parse(kk)
    //   console.log('kk :>> ', kk['enterName']);

    //   setTimeout(() => {
    //     JSON.parse(that.$store.state.userInfo)
    //     let promise = that.tim.updateMyProfile({
    //       nick: JSON.parse(that.$store.state.userInfo).nickname.toString()+` (${kk['enterName']})`,
    //       avatar: JSON.parse(that.$store.state.userInfo).avatar,
    //       gender: that.TIM.TYPES.GENDER_MALE,
    //       // selfSignature:  kk['enterName'] ,
        
    //       allowType: that.TIM.TYPES.ALLOW_TYPE_ALLOW_ANY
    //     });
    //     promise.then(function (imResponse) {
    //       console.log(imResponse.data,'更新资料成功'); // 更新资料成功
    //     }).catch(function (imError) {
    //       console.warn('updateMyProfile error:', imError); // 更新资料失败的相关信息
    //     });

    //   }, 2000)
    //   console.log('987644',546465465655656465555)

    //   // this.sendmsg()
    // } catch (e) {
    //   //TODO handle the exception
    // }
    // let addr = this.$store.state.point;
    // if (!addr.latitude) {
    //   this.$store.dispatch("getArea");
    // }
  },
  watch: {

  },

  methods: {

  
    // resizeFun () {
    //   const devicePixelRatio = window.devicePixelRatio // 获取下载的缩放 125% -> 1.25    150% -> 1.5
    //   if (devicePixelRatio > 1.25) {
    //     // 如果在笔记本中用IE浏览器打开 则弹出提示
    //     if (!! window.ActiveXObject || 'ActiveXObject' in window) {
    //       alert('balabala。。。')
    //     } else {
    //       const c = document.querySelector('HTML')
    //       c.style.zoom = 1/ devicePixelRatio// 修改页面的缩放比例
    //     }
    //   }
    // },

    
  //  async logins(uname) {
  //     let that = this
  //     console.log('hah', uname);
  //     // let userSig = genTestUserSig(uname.toString()).userSig
  //     let userSig = await getusersig({ memberId: uname.toString()+'hr' })
  //     console.log(userSig.data,'99999999')
  //     let promise = this.tim.login({
  //       userID: uname.toString()+'hr',
  //       userSig: userSig.data
  //     });
  //     promise.then(function (imResponse) {
  //       console.log(imResponse.data, `登录成功${uname}`); // 登录成功
  //       console.log(imResponse.data.errorInfo);
  //       console.log(that.$store, 1232, uname);
  //       if (imResponse.data.repeatLogin === true) {
  //         // 标识帐号已登录，本次登录操作为重复登录。v2.5.1 起支持
  //       }

  //     }).catch(function (imError) {
  //       console.warn('login error:', imError); // 登录失败的相关信息
  //     });
  //   },
  }
};

</script>

<style lang="less">
@import url('~@/assets/font/font.less');
</style>



// WEBPACK FOOTER //
// src/App.vue